/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function HomeIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" {...props}>
      <path d="M10 2.69L15 7.19V15H13V9H7V15H5V7.19L10 2.69ZM10 0L0 9H3V17H9V11H11V17H17V9H20L10 0Z" />
    </SvgIcon>
  );
}
